import { render, staticRenderFns } from "./BCKeyAssignmentSideKey.vue?vue&type=template&id=4be17474&scoped=true"
import script from "./BCKeyAssignmentSideKey.vue?vue&type=script&lang=js"
export * from "./BCKeyAssignmentSideKey.vue?vue&type=script&lang=js"
import style0 from "./BCKeyAssignmentSideKey.vue?vue&type=style&index=0&id=4be17474&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4be17474",
  null
  
)

export default component.exports